import { CloseButton } from "frontend/ui-components/dialog-close-button/dialog-close-button";
import S from "./confirm-if-no-mapping.module.css";

export function ConfirmCreationWithoutMapping({
  onContinue,
  onBackToMapping,
}: {
  onContinue: () => void;
  onBackToMapping: () => void;
}) {
  return (
    <div className={S.container}>
      <CloseButton onClick={onBackToMapping} />
      <h1>Continue without full mapping?</h1>
      <p>
        Some content isn&rsquo;t mapped and <b>will be lost.</b>
      </p>
      <p>Continue anyway?</p>
      <div style={{ display: "grid", gridTemplate: "1fr / 1fr 1fr", gap: "15px", marginTop: "20px" }}>
        <button className={S.primaryButton} onClick={onBackToMapping} data-testid="keep-mapping">
          Keep mapping
        </button>
        <button className={S.secondaryButton} onClick={onContinue} data-testid="continue-without-mapping">
          Continue without
        </button>
      </div>
    </div>
  );
}
